export default __webpack_public_path__ + "static/media/ImageOne.2bc4cf73.jpg";